import { render, staticRenderFns } from "./ChannelMultiplePickerInput.vue?vue&type=template&id=4e15463a&scoped=true&"
import script from "./ChannelMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./ChannelMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15463a",
  null
  
)

export default component.exports